import { TimelineMax, Expo } from 'gsap';

export default function fade(el) {
  const tl = new TimelineMax({
    paused: true,
  });

  tl
    .addLabel('start')
    .to(el, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    }, 'start');

  return tl;
}
